import {CancellationPoliciesContent as SharedCancellationPolicies} from '@/customComponents/globalComponents/policiesContent.jsx'
import {bookingPolicyValues} from '@/customComponents/globalComponents/policyValues.js'

// Booking-flow cancellation & change policy — dynamic, from /calculate-policies.
// Reads the cached policies (primed by the modalPages gate in hopnModal) via
// POLICY_CONSTANTS, so it NEVER triggers its own fetch. That makes it safe even
// when rendered outside the gated modal (e.g. the airport-perks popup): if
// policies aren't loaded it shows the contact-us empty state rather than warming
// the cache with no-trip params.
export function CancellationPoliciesContent() {
    return <SharedCancellationPolicies policy={bookingPolicyValues()}/>
}

export default CancellationPoliciesContent
